import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { SpinoffAuthService } from '@sbe-spinoff-client/spinoff-platform';
import { BootGateService } from './boot-gate.service';

// app.config.ts가 더 이상 부트스트랩 자체를 블로킹하지 않는다(2026-09-24, 콜드스타트 로딩
// UI 도입) — 그래서 이 가드가 직접 부팅 시퀀스(auth.init() + 레거시 세션 계승) 완료를
// 기다려야, 계승 중인 사용자를 미인증으로 오판해 /login으로 튕겨내지 않는다.
export const authGuard: CanActivateFn = async () => {
  const auth = inject(SpinoffAuthService);
  const bootGate = inject(BootGateService);
  const router = inject(Router);
  await bootGate.whenReady();
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/login']);
};
